import React from 'react';
import {
  BlobProvider,
  Document,
  Image,
  Page,
  Text,
  View,
} from '@react-pdf/renderer';
import styles from '../Styles';
// import logo from '../../assets/images/logo.png';

function calculateDescriptionLength(props) {
  const length =
    (props.descriptionShort ? props.descriptionShort.length : 0) +
    (props.descriptionLong ? props.descriptionLong.length : 0);
  
  return length;
}
// Create Document Component
const PdfDoc = (props, carStepVisible, bookStepVisible) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header} fixed>
        <View>
          <Text style={styles.headerText}>Item Report</Text>
        </View>
        <Image
          style={styles.headerImage}
          src="/images/47bd58173a3935d2cd74086fe7011a37.png"
        />
      </View>
      <View style={styles.body}>
        {/* Object overview */}
        <View wrap={false}>
          <View style={styles.sectionTitle}>
            <Text>Object Overview</Text>
          </View>
          <View style={styles.section}>
            {/* Col 1 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Object Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.objectNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Object Name:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.objectName}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Subtitle:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.subtitle}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Classification:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.classification}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Category:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.category}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Subcategory:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.subCategory}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Date Received:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.dateReceived}</Text>
                </View>
              </View>
            </View>
            {/* Col 2 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Length (cm):</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.length}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Width (cm):</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.width}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Height (cm):</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.height}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Weight (kg):</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.weight}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Diameter (cm):</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.diameter}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Other Dimensions:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.otherDimensions}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        {/* Location */}
        <View wrap={false}>
          <View style={styles.sectionTitle}>
            <Text>Location</Text>
          </View>
          <View style={styles.section}>
            {/* Col 1 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Location Name:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.locationName}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Building Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.buildingNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Building Area:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.buildingArea}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Hall Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.hallNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Room Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.roomNumber}</Text>
                </View>
              </View>
            </View>
            {/* Col 2 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Temporary Location:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.temporaryLocation ? 'Yes' : 'No'}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Cabinet Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.cabinetNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Shelf Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.shelfNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Drawer Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.drawerNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Box Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.boxNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Showcase No:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.showcaseNumber}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        {/* Description */}
        <View wrap={calculateDescriptionLength(props) > 3000}>
          <View style={styles.sectionTitle}>
            <Text>Description</Text>
          </View>
          <View style={styles.descriptionSection1}>
            {/* Col 1 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Tag Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.tagNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Barcode:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.barcode}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Label:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.label}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Object Title:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.objectTitle}</Text>
                </View>
              </View>
              {/* TODO: add material list */}
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Technology:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.technology}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Surface:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.surface}</Text>
                </View>
              </View>
            </View>
            {/* Col 2 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Description Short:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.descriptionShort}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Inscription Language:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.language}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Inscription Notes:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.inscriptionNotes}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Material Technique:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.materialTechnique}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Currency:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.currency}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Value:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.value}</Text>
                </View>
              </View>
            </View>
          </View>
          {/* Descriptin long */}
          <View style={styles.descriptionSection2}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                margin: 6,
                marginTop: 0,
                padding: 6,
                paddingTop: 0,
              }}
            >
              <View style={{ width: '100%', fontSize: 10 }}>
                <Text>Description Long:</Text>
              </View>
              <View style={{ width: '100%', fontSize: 10, marginTop: 2 }}>
                {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                <Text>{props.descriptionLong}</Text>
              </View>
            </View>
          </View>
        </View>
        {/* Origin */}
        <View wrap={false}>
          <View style={styles.sectionTitle}>
            <Text>Origin</Text>
          </View>
          <View style={styles.section}>
            {/* Col 1 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Geographical Area:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.geographicalArea}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Country:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.country}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Area:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.area}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Century:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.century}</Text>
                </View>
              </View>
            </View>
            {/* Col 2 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Author:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.author}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Publishing House:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.publishingHouse}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Insurance Number:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.insuranceNumber}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Hijri Year:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.hijriYear}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Gregorian Year:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.gregorianYear}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Method:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.method}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        {/* Car Details */}
        {carStepVisible && (
          <View wrap={false}>
            <View style={styles.sectionTitle}>
              <Text>Car Details</Text>
            </View>
            <View style={styles.section}>
              {/* Col 1 */}
              <View style={styles.col}>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Brand:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.brand}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Model:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.model}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Registration:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.registration}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Colour:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.colour}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Body Manufacturer:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.bodyManufacturer}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Vehicle Type:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.vehicleType}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Num of Cylinders:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.numOfCylinders}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Horse Power:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.horsePower}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Year of Production:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.yearOfProduction}</Text>
                  </View>
                </View>
              </View>
              {/* Col 2 */}
              <View style={styles.col}>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Max Speed:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.maxSpeed}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Price at Auct:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.priceAtAuct}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Youtube Link:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.youtubeLink}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Special History:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.specialHistory}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Special Features:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.specialFeatures}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Mileage:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.mileage}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Tyre Size:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.tyreSize}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Plate Number:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.plateNumber}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        )}
        {/* Book Details */}
        {bookStepVisible && (
          <View wrap={false}>
            <View style={styles.sectionTitle}>
              <Text>Book Details</Text>
            </View>
            <View style={styles.section}>
              {/* Col 1 */}
              <View style={styles.col}>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Second Author:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.secondAuthor}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Contributor:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.contributor}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Translator:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.translator}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Editor:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.editor}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Edition:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.edition}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Copyright:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.copyright}</Text>
                  </View>
                </View>
              </View>
              {/* Col 2 */}
              <View style={styles.col}>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Publishing Home:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.publishingHome}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Volume:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.volume}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Pages:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.pages}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Subject:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.subject}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Identifier:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.identifier}</Text>
                  </View>
                </View>
                <View style={styles.line}>
                  <View style={styles.label}>
                    <Text>Material Type:</Text>
                  </View>
                  <View style={styles.lineText}>
                    {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                    <Text>{props.materialType}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        )}
        {/* Media */}
        <View wrap={false}>
          <View style={styles.sectionTitle}>
            <Text>Media</Text>
          </View>
          <View style={styles.section}>
            {/* Col 1 */}
            <View style={styles.col}>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Photographer:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.photographer}</Text>
                </View>
              </View>
              <View style={styles.line}>
                <View style={styles.label}>
                  <Text>Date Taken:</Text>
                </View>
                <View style={styles.lineText}>
                  {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
                  <Text>{props.dateTaken}</Text>
                </View>
              </View>
            </View>
            <View style={styles.colBorderless} />
            {/* REMEMBER THAT I HAD TO SET CORS FOR GOOGLE CLOUD STORAGE */}
          </View>
        </View>

        <View
          // eslint-disable-next-line react/destructuring-assignment,react/prop-types
          wrap={props.imageList && props.imageList.length > 16}
          style={styles.imageList}
        >
          {// eslint-disable-next-line react/destructuring-assignment,react/prop-types
          props.imageList ? (
            // eslint-disable-next-line react/prop-types,react/destructuring-assignment
            props.imageList.map(image => {
              return (
                // eslint-disable-next-line react/jsx-key
                <View style={styles.image}>
                  {image.url !== '' && <Image src={image.url} />}
                </View>
              );
            })
          ) : (
            <View />
          )}
        </View>
      </View>
      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
    </Page>
  </Document>
);

const ItemReportPdf = props => (
  <div>
    <BlobProvider
      // eslint-disable-next-line react/prop-types,react/destructuring-assignment
      document={PdfDoc(props.item, props.carStepVisible, props.bookStepVisible)}
    >
      {({ blob, url, loading, error }) => {
        
        // Do whatever you need with blob here
        
        
        
        

        if (url && loading === false) {
          const today = new Date();
          const currentDate =
            today.getFullYear() +
            '-' +
            (today.getMonth() + 1) +
            '-' +
            today.getDate();
          
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            // eslint-disable-next-line react/prop-types
            'item_' + props.item.objectNumber + '_(' + currentDate + ').pdf',
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          // eslint-disable-next-line react/prop-types
          props.callback();
        }
        return <div></div>;
      }}
    </BlobProvider>
  </div>
);

export default ItemReportPdf;
